<template>
<b-container fluid class="container">
   <b-row v-if="this.inicio == null">
            <b-col cols="9" class="text-left" style="background-color: #DD3E23;">
              <b-button @click.prevent="sesion()" style="color: white" class="m-2" variant="link">Iniciar Sesión</b-button>
            </b-col>
            <b-col class="text-right" style="background-color: #DD3E23;">
              <b-nav pills>
                <b-dropdown text="Menú" variant="outline-light" class="m-2">
                  <b-dropdown-item @click.prevent="principal()">Inicio</b-dropdown-item>                  
                  <b-dropdown-item @click.prevent="reservar()">Reservar Unidad</b-dropdown-item>
                  <b-dropdown-item @click.prevent="financiamiento()">Financiamiento</b-dropdown-item>
                  <b-dropdown-item @click.prevent="contado()">Contado</b-dropdown-item>
                </b-dropdown>
              </b-nav>
            </b-col>
   </b-row>
    <b-row v-if="this.inicio != null">
      <b-col class="text-left" style="background-color: #DD3E23;">
        <b-dropdown id="dropdown-left" text="Sesión Iniciada" variant="outline-light" class="m-2">
          <b-dropdown-item @click.prevent="personales()">Información Personal</b-dropdown-item>
          <b-dropdown-item @click.prevent="reservar()">Reservar Unidad</b-dropdown-item>
          <b-dropdown-item @click.prevent="financiamiento()">Financiamiento</b-dropdown-item>
          <b-dropdown-item @click.prevent="contado()">Contado</b-dropdown-item>
          <b-dropdown-item @click.prevent="cerrar()">Cerrar Sesión</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col class="text-right" style="background-color: #DD3E23;">
        <p class="m-3" style="color: white;"> {{this.nombre}} </p>
      </b-col>
    </b-row>
   <!-- Modal de Sesión -->
      <b-modal v-model="access" hide-footer header-bg-variant="danger" headerTextVariant="light">
      <b-container fluid>
        <b-row cols="1" class="mb-1 justify-content-md-center">
          <b-col cols="12" class="text-center"><h1>Bienvenido</h1> </b-col>
          <b-col cols="12" class="text-center"><p style="font-size: 13px">Ingresa tu usuario y contraseña</p> </b-col>
              <div class="col-md-9">
                <b-col>
                  <b-form-input type="text" class="inputModal" v-model="usuario" placeholder="Usuario" maxlength="26" required></b-form-input>
                </b-col>
              </div>
              <div class="col-md-9 mt-3">
                <b-col>
                  <div class="input-group mb-3">
                    <b-form-input id="password" type="password" class="inputModal" v-model="contrasenia" placeholder="Contraseña" maxlength="26" required></b-form-input>
                    <b-button @click.prevent="mostrarContrasena()" class="button_pass" variant="primary"><b-icon icon="eye" aria-hidden="true"></b-icon></b-button>  
                  </div>
                </b-col>
              </div>

              <b-col v-if="this.errorLogin == true" cols="12" class="mt-3 text-center">
                  <p style="color: red" >{{this.merror}}</p>
              </b-col>

              <b-col cols="12" class="mt-3 text-center">
                <b-form-checkbox id="checkbox-3" name="checkbox-3" value="accepted" unchecked-value="not_accepted">
                  Recordar Siempre
                </b-form-checkbox>
              </b-col>
              <b-col class="mt-3">
                <b-button @click.prevent="iniciar()" variant="danger" class="button_H">INICIAR SESIÓN</b-button>
              </b-col>
              <b-col cols="12" class="text-center">
                <b-button @click.prevent="recover()" style="color: #0080FF" variant="link">¿Olvidaste tu contraseña?</b-button>
              </b-col>
        </b-row>
      </b-container>
    </b-modal>

</b-container>
</template>

<script>

export default {
  name: 'Sesion',

    data() {
    return {
        logout: '',
        merror: '',
        inicio: sessionStorage.getItem("session"),
        nombre: sessionStorage.getItem("nombre")+' '+sessionStorage.getItem("paterno")+' '+sessionStorage.getItem("materno"),
        usuario: '',
        contrasenia: '',
        access:false,
        session: false,
        errorLogin: false,
        continuar: sessionStorage.getItem("continuar"),
      };
  },

  methods: {

       sesion(){
          this.access= true;
        },

        cerrar(){
              let user = { }

              this.logout = sessionStorage.getItem("session");
              axios.put("https://qasrv-login.autocom.mx/api/Customer/CloseSessionCustomer/"+this.logout+"/Reservas", user, {
              headers: {
              Authorization: "Bearer " + sessionStorage.getItem("tknUser"),
              'Content-Type': 'application/json',
              },
            }).then(response =>{
                this.acceso = response.data.status;
                if (this.acceso == 'success'){
                  sessionStorage.removeItem("session");
                  sessionStorage.removeItem("nombre");
                  sessionStorage.removeItem("paterno");
                  sessionStorage.removeItem("materno");
                  sessionStorage.removeItem("loginAct");
                    this.continuar = false; 
                    sessionStorage.setItem("continuar", this.continuar);
                  this.refresh();
                }
              }).catch(error=>{
                  console.log(error)
              });
        },

        iniciar(){
            let userTk = {
            username: "marco.villegas@autocom.mx",
            //password: "B8jc8q!n"}; //qa
            password: "Asd12345"}; //prod
            axios.post("https://qasrv-login.autocom.mx/api/Token/login", userTk)
              .then((response) => {
                this.contents = response.data.token;
                sessionStorage.setItem("tknUser", response.data.token);
                this.login();
              });
        },
        login(){

          if(this.usuario != '' && this.contrasenia != '') {
              let user = {
                  username: this.usuario,
                  password: this.contrasenia,
                  app: 'Reservas',
              }

            axios.post('https://qasrv-login.autocom.mx/api/Customer/IdentifyCustomer', user,  {
              headers: {
              Authorization: "Bearer " + sessionStorage.getItem("tknUser"),
              'Content-Type': 'application/json',
              }, 
              }).then(response =>{
                this.acceso = response.data.status;
                if (this.acceso == 'success'){
                    this.session = response.data.qisId;
                    sessionStorage.setItem("nombre", response.data.customerName);
                    sessionStorage.setItem("paterno", response.data.customerSurname);
                    sessionStorage.setItem("materno", response.data.customerSurname2);
                    sessionStorage.setItem("mail", response.data.customerEmail);
                    sessionStorage.setItem("telefono", response.data.customerPhone);
                    sessionStorage.setItem("loginAct", this.session);
                    sessionStorage.setItem("session", this.session);
                    this.continuar = true; 
                    sessionStorage.setItem("continuar", this.continuar);
                    this.refresh();
                    this.access = false;
                } else {
                  this.errorLogin = true;
                  this.merror = response.data.message;
                }
              }).catch(error=>{
                  console.log(error)
              });
           } else { 
                  this.errorLogin = true;
                  this.merror = 'Se requiere de un usuario y una contraseña';
           }
        },

        refresh(){
          location.reload();
        },

        recover(){
          this.$router.push({ path: '/Recover'});
        },

        personales(){
          this.$router.push({ path: '/InformacionPersonal'});
        },

        financiamiento(){
          this.$router.push({ path: '/Financiamiento'});
        },

        contado(){
          this.$router.push({ path: '/Contado'});
        },

        reservar(){
          this.$router.push({ path: '/Reserva'});
        },

        principal(){
          this.$router.push({ path: '/Bienvenida'});
        },
        mostrarContrasena(){
              var tipo = document.getElementById("password");
              if(tipo.type == "password"){
                  tipo.type = "text";
              }else{
                  tipo.type = "password";
              }
          },

        inicios(){
          console.log('Inicio -->',this.inicio);
        }

    },

  created() {

  }
}
</script>

<style scoped>


</style>